var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPersonCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.1481H11V18.3981C10.9986 17.1561 9.99207 16.1495 8.75 16.1482H5.75C4.50793 16.1495 3.50135 17.1561 3.5 18.3981V22.1481H2V18.3981C2.00247 16.3281 3.67992 14.6506 5.75 14.6482H8.75C10.8201 14.6506 12.4975 16.3281 12.5 18.3981V22.1481Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 7.14816C8.49267 7.14816 9.5 8.15548 9.5 9.39816C9.5 10.6408 8.49267 11.6482 7.25 11.6482C6.00733 11.6482 5 10.6408 5 9.39816C5.00143 8.15608 6.00793 7.14958 7.25 7.14816ZM7.25 5.64816C5.17895 5.64816 3.5 7.32711 3.5 9.39816C3.5 11.4692 5.17895 13.1482 7.25 13.1482C9.32105 13.1482 11 11.4692 11 9.39816C11 7.32711 9.32105 5.64816 7.25 5.64816Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6.1339L15.0575 4.1914L14 5.2489L17 8.2489L22.25 2.9989L21.1925 1.9414L17 6.1339Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersonCheck);
export default __webpack_public_path__ + "static/media/ic-person-check.0d26d9793480edaeeed48afdee8f1eb2.svg";
export { ForwardRef as ReactComponent };